import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import pattern from "../../Assets/pattern.svg";

import aboutHeroImage from "../../Assets/about-hero.png";
import iso9001 from "../../Assets/ISO9001-2015.png";

import { GrCompliance } from "react-icons/gr";
import { LuHandshake } from "react-icons/lu";
import { LuImageUpscale } from "react-icons/lu";
import { IoMdGlobe } from "react-icons/io";
import { LuUserSearch } from "react-icons/lu";
function About() {
    return (
        <div>
            <section className='section-hero'>
                <Container fluid className="header-section">
                    <Row style={{ background: "#1b3f38" }}>
                        <Col md={12} >
                            <div className="padding-section-large text-center d-flex flex-column text-white">
                                <div className="max-width-large mx-auto">
                                    <h1 className="heading-style-h1">About CeWaves</h1>
                                </div>
                                <div className='pt-2 max-width-medium mx-auto'>
                                    <p className="text-size-medium">Accelerating Talent. Powering Global Enterprises.</p>
                                </div>
                            </div>
                        </Col>
                        <div className='position-absolute top-0 left-0 w-100 h-100'>
                            <Image src={pattern} />
                        </div>

                    </Row>
                </Container >
            </section >
            <section className="position-relative">
                <div className='p-5'>
                    <div className="row align-items-center">
                        <div className="col-md-8 pe-md-5 pb-5" >
                            <h1 className="pb-3">Who We Are</h1>
                            <p className="text-size-large pe-5">We specialize in enterprise-grade staffing solutions tailored to diverse business requirements across industries and geographies. Our approach blends speed, compliance, and precision hiring, enabling organizations to stay agile in competitive markets.
                            </p>
                            <p className="text-size-medium pe-5">With a deep understanding of global workforce dynamics, we act as an extension of your talent team—focused on quality, continuity, and long-term success.
                            </p>
                        </div>
                        <div className="col-md-4">
                            <Image src={aboutHeroImage} className="img-fluid" />
                        </div>
                    </div>
                </div>
                <div className="framer"></div>
            </section>
            <section className='padding-section-large bg-black text-white px-5 border-bottom'>
                <div className="container">
                    <p className="text-size-large text-white pb-4">We are a trusted staffing and workforce solutions partner delivering compliant IT and Non-IT talent to global enterprises across industries. Our mission is simple — connect businesses with the right talent, at the right time, with zero compromise on quality or compliance.
                    </p>
                    <p className="text-size-large text-white pb-4">With deep expertise in global hiring models, we support organizations in scaling teams efficiently, reducing delivery risk, and driving sustainable growth. Our partnerships with leading enterprises such as IFF, Randstad, Tory Burch, NCC, and VFast reflect our ability to meet diverse workforce demands with precision and reliability.</p>
                    <p className="text-size-large text-white">What sets us apart is our single-provider staffing model, offering end-to-end workforce solutions under one roof — enabling faster hiring, operational continuity, and cost efficiency.</p>

                </div>

            </section>
            <section className='padding-section-large px-5'>
                <Row className='mb-4'>
                    <h1 className=''>Why Partner With Us</h1>
                    <p className="text-size-large">We don’t just fill roles — we build workforce ecosystems that drive performance and innovation.</p>

                </Row>
                <div className="d-md-flex gap-4 pt-3 text-dark">

                    <div className="col bg-white shadow-sm gap-2 border rounded p-3 mb-4 mb-md-0">
                        <IoMdGlobe className='display-1 mb-3' />
                        <h4>Proven experience with global enterprise clients</h4>
                    </div>
                    <div className="col bg-white shadow-sm gap-2 border rounded p-3 mb-4 mb-md-0">
                        <LuImageUpscale className='display-1 mb-3' />
                        <h4>Scalable IT & Non-IT staffing solutions</h4>
                    </div>
                    <div className="col bg-white shadow-sm gap-2 border rounded p-3 mb-4 mb-md-0">
                        <LuUserSearch className='display-1 mb-3' />
                        <h4>Faster turnaround and reduced hiring risk</h4>
                    </div>
                    <div className="col bg-white shadow-sm gap-2 border rounded p-3 mb-4 mb-md-0">
                        <GrCompliance className='display-1 mb-3' />
                        <h4>Strong compliance and governance frameworks</h4>
                    </div>
                    <div className="col bg-white shadow-sm gap-2 border rounded p-3">
                        <LuHandshake className='display-1 mb-3' />
                        <h4>Long-term talent partnerships, not transactional hiring</h4>
                    </div>
                </div>
            </section>
            <section className="py-5 bg-light" id="certifications">
                <div className="container">
                    <div className="row align-items-center g-5">

                        {/* Left Side - Image */}
                        <div className="col-md-5 text-center">
                            <Image src={iso9001} className="w-25 pt-5" />

                            <div className="mt-3">
                                <a
                                    href="/certificates/CEWAVES_TECHNOLOGIES_QMS.pdf"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-dark w-auto mt-0 mt-md-5 text-uppercase"
                                >
                                    View Certificate
                                </a>
                            </div>
                        </div>

                        {/* Right Side - Content */}
                        <div className="col-md-7">
                            <span className="badge bg-success mb-2">Certified</span>
                            <h2 className="fw-bold mb-3">ISO 9001:2015 Certified</h2>

                            <p className="text-size-large">
                                CeWaves Technologies Private Limited is ISO 9001:2015 certified
                                for its Quality Management System, reflecting our commitment to
                                consistent quality, operational excellence, and customer
                                satisfaction.
                            </p>

                            <ul className="list-unstyled mt-4 text-size-large">
                                <li className="mb-2">✔ International Quality Standards</li>
                                <li className="mb-2">✔ Continuous Process Improvement</li>
                                <li className="mb-2">✔ Customer-Focused Delivery</li>
                            </ul>

                            <div className="mt-3 text-muted">
                                <strong>Standard:</strong> ISO 9001:2015 <br />
                                <strong>Scope:</strong> Software Development, IT Services &
                                Consulting
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </div>
    );
}

export default About;